export default __webpack_public_path__ + "static/media/activity-1.f903f1a7.png";